import e from"react";import{Container as a}from"./styles.js";const t=t=>{let{children:r,animated:l=!1,description:m,className:s}=t;return e.createElement(a,{animated:l,"aria-label":m,className:s},r)};t.displayName="Skeleton";export{t as Skeleton};
//# sourceMappingURL=Skeleton.js.map
